export const AaisTheme = {
  palette: {
    primary: {
      main: "#1f4287",
      light: "#5091cd",
      dark: "#143068",
      contrastText: "#ffffff",
    },
    action: {
      hover: "rgba(213, 235, 255, 0.08)",
      hoverOpacity: 0.08,
    },
    secondary: {
      main: "#dc0000",
      light: "#ffd4d4",
      dark: "#000000",
      contrastText: "#ffffff",
    },
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
    fontSize: 12,
    useNextVariants: true,
  },
};
